export class HttpResponseCodes {
  public static success = 200;
  public static conflict = 409;
}
